import { useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import ShipmentIcon from 'components/icons/ShipmentIcon';
import Button from 'components/new-ui/base/button/Button';
import PageHeader from 'components/new-ui/base/page-header/PageHeader';
import ArchivationStatusFilter from './ArchivationStatusFilter';

type Status = 'active' | 'archived';

type Props = {
    status: Status;
    canCreateManifests: boolean;
    onStatusChange: (s: Status) => void;
};

const ManifestDashboardHeader = ({ canCreateManifests, status, onStatusChange }: Props) => {
    const navigate = useNavigate();

    const handleCreateManifest = () => {
        navigate('/manifests/new');
    };

    return (
        <PageHeader
            title="Manifests"
            icon={<ShipmentIcon />}
            sidebar={
                <div>
                    <ArchivationStatusFilter value={status} onChange={onStatusChange} />
                    {canCreateManifests && (
                        <Button icon={<PlusOutlined />} type="primary" onClick={handleCreateManifest}>
                            New Manifest
                        </Button>
                    )}
                </div>
            }
        />
    );
};

export default ManifestDashboardHeader;
